import { Component, OnInit, ViewContainerRef, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { YoutubeVideoComponent } from '../youtube-video/youtube-video.component';
import { TextBoxComponent } from '../text-box/text-box.component';
import { UrlBoxComponent } from '../url-box/url-box.component';
import { ImageComponent } from '../image/image.component';
import { SliderComponent } from '../slider/slider.component';
import { VideoComponent } from '../video/video.component';
import { CardsComponent } from '../cards/cards.component';
import { NewPageList } from '../../core/models/new-page-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ListComponent } from '../list/list.component';
import { ListWithinList } from '../../core/models/list-within-list';
import { StaticCompComponent } from '../static-comp/static-comp.component';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
  providers: [NewPageService]
})
export class DropDownComponent implements OnInit {

  @ViewChild('template', { read: ViewContainerRef }) template: ViewContainerRef;

  listing: boolean = true;
  message: string;
  eventId: string;
  show: boolean = true;
  _ref: any;
  cmCategory: string;
  aboutUs = new NewPageList();


  constructor(private _cfr: ComponentFactoryResolver, private newPageService: NewPageService) {

  }

  ngOnInit() {
  }

  addYoutube() {
    var youtube = this._cfr.resolveComponentFactory(YoutubeVideoComponent);
    var expComponent = this.template.createComponent(youtube);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventYouTubeVideo = false;
    }
    expComponent.instance.eventId = this.eventId;
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'youtubeVideo';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addTextBox() {
    var textBox = this._cfr.resolveComponentFactory(TextBoxComponent);
    var expComponent = this.template.createComponent(textBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'text';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addUrlBox() {
    var urlBox = this._cfr.resolveComponentFactory(UrlBoxComponent);
    var expComponent = this.template.createComponent(urlBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventURL = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'url';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addImage() {
    var image = this._cfr.resolveComponentFactory(ImageComponent);
    var expComponent = this.template.createComponent(image);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventImage = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'image';
    expComponent.instance.eventId = this.eventId;
    expComponent.instance.cmCategory = this.cmCategory;
    expComponent.instance.aboutUs = this.aboutUs;
    expComponent.instance.message = this.message;
    this.listing = false;
  }

  addImageSlider() {
    console.log(this.cmCategory, 'image Slider');
    var imageSlider = this._cfr.resolveComponentFactory(SliderComponent);
    var expComponent = this.template.createComponent(imageSlider);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventSlider = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'imageSlider';
    expComponent.instance.eventId = this.eventId;
    expComponent.instance.cmCategory = this.cmCategory;
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addVideo() {

    if (this.aboutUs.contentMandatoryList[0]) {
      this.newPageService.getContentsMandatory(this.aboutUs.contentMandatoryList[0], this.eventId).subscribe((conMan) => {
        this.newPageService.getFile(conMan, this.eventId).then((url) => {
          var video = this._cfr.resolveComponentFactory(VideoComponent);
          var expComponent = this.template.createComponent(video);
          expComponent.instance._ref = this._ref;
          this.aboutUs.type = 'video';
          expComponent.instance.eventId = this.eventId;
          expComponent.instance.cmCategory = this.cmCategory;
          expComponent.instance.aboutUs = this.aboutUs;
          expComponent.instance.src = url;
          this.listing = false;
        });
      });
    } else {
      var video = this._cfr.resolveComponentFactory(VideoComponent);
      var expComponent = this.template.createComponent(video);
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'video';
      expComponent.instance.eventId = this.eventId;
      expComponent.instance.cmCategory = this.cmCategory;
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.eventVideos = false;
      this.listing = false;
    }
  }

  addCards() {
    var cards = this._cfr.resolveComponentFactory(CardsComponent);
    var expComponent = this.template.createComponent(cards);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventCard = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'cards';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addList() {
    var list = this._cfr.resolveComponentFactory(ListComponent);
    var expComponent = this.template.createComponent(list);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventList = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'list';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addStatic(value: string) {
    var staticComp = this._cfr.resolveComponentFactory(StaticCompComponent);
    var expComponent = this.template.createComponent(staticComp);
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = value;
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/drop-down/drop-down.component.ts